/**
 * A spend against a stale credit balance — a credit shown as available but
 * already reserved in another tab or session — answers HTTP 402 with an
 * `insufficient_credits` body, so the send/self flow can fall back to the
 * top-up path instead of treating an expected billing race as a failure.
 * See backend/src/Billing/Http/InsufficientCreditsListener.php.
 */
export default function isInsufficientCreditsError(error: unknown): boolean {
  return (
    !!error &&
    typeof error === "object" &&
    "status" in error &&
    error.status === 402
  )
}
